
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    selectedSort: "",
    sortList: [
      { value: "alphabetical-order", label: "Alphabetical Order" },
      { value: "time-added", label: "Time Added" },
      // { value: "custom", label: "Custom" },
      { value: "price-low-to-high", label: "Price Low to High" },
      { value: "price-high-to-low", label: "Price High to Low" }
    ]
  }),
  mounted() {
    this.selectedSort = this.sortOrder;
  },
  computed: {
    ...mapState("menu", ["sortOrder"])
  },
  methods: {
    ...mapMutations("menu", ["SET_SORT_ORDER"]),
    sortchanged(val) {
      this.SET_SORT_ORDER(val);
    }
  }
};
